import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import FanBuddySwipeCard from "./FanBuddySwipeCard";
import MutualMembersBottomDrawer from '../drawer/MutualMembersBottomDrawer';
import { useState } from 'react';

const AlertDialog = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(13px);
  -webkit-backdrop-filter: blur(13px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const FanBuddyCardDialog = ({isAlertOpen, setIsAlertOpen, isMine, currentUser, buddyPreference}) => {
  const navigate = useNavigate();
  const [isShowMutualMemberBottomSheet, setIsShowMutualMemberBottomSheet] = useState(false);

  const handleSelectMatching = () => {
    if(isMine) {
      navigate(`/fan-buddy/show-fan-buddy-card?mbti=${buddyPreference.mbti}`)
    } else if (currentUser?.baseUserProfile){
      navigate(`/fan-buddy/matching?sourceUserProfileId=${currentUser.baseUserProfile.userProfileId}&targetUserProfileId=${buddyPreference.userProfileId}&newTabOpen=true`)
    }
  }

  return(
    <AnimatePresence>
      {isAlertOpen && (
        <AlertDialog
          onClick={() => setIsAlertOpen(false)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ y: -50, scale: 0.95 }}
            animate={{ y: 0, scale: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            className='bg-pure-white dark:bg-pure-black rounded-[16px] max-w-[327px] relative'
            style={{
              placeItems: 'center',
            }}
          >
            <FanBuddySwipeCard
              isMine={isMine}
              buddyUserProfile={buddyPreference}
              currentUserKeywords={buddyPreference?.keywords}
              onSelectedMutualMembers={() => setIsShowMutualMemberBottomSheet(true)}
              onSelectedMatching={() => handleSelectMatching()}
              onSelectedBuddyUserProfile={() => {}}
            />
          </motion.div>
        </AlertDialog>
      )}
      {
        isShowMutualMemberBottomSheet &&
        <MutualMembersBottomDrawer
          isOpen={isShowMutualMemberBottomSheet}
          onClose={() => setIsShowMutualMemberBottomSheet(false)}
          members={buddyPreference.mutualMembers}
        />
      }
    </AnimatePresence>
  )
}
